// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/typeface-roboto/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/@osjs/gui/dist/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/@osjs/dialogs/dist/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/@osjs/panels/dist/main.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,400i,700,900);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-family: "Lato";
}

.osjs-window-header {
  height: 3em;
}

.osjs-window-icon > i {
  height: 1em;
  width: 1em;
  margin-left: 6px;
}

.osjs-notifications {
  top: 45px;
}

.fa {
  font-family: "Font Awesome 6 Pro" !important;
}

.osjs-panel-item .logo-here img {
  width: 75px;
  padding: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/client/assets/scss/index.scss"],"names":[],"mappings":"AAMA;EACE,mBAAA;AAAF;;AAEA;EACE,WAAA;AACF;;AACA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;AAEF;;AAAA;EACE,SAAA;AAGF;;AAAA;EACE,4CAAA;AAGF;;AAAA;EACE,WAAA;EACA,cAAA;AAGF","sourcesContent":["@import \"~typeface-roboto/index.css\";\n@import \"~@osjs/gui/dist/main.css\";\n@import \"~@osjs/dialogs/dist/main.css\";\n@import \"~@osjs/panels/dist/main.css\";\n@import url(\"https://fonts.googleapis.com/css?family=Lato:400,400i,700,900\");\n\nhtml {\n  font-family: \"Lato\";\n}\n.osjs-window-header {\n  height: 3em;\n}\n.osjs-window-icon > i {\n  height: 1em;\n  width: 1em;\n  margin-left: 6px;\n}\n.osjs-notifications {\n  top: 45px;\n}\n\n.fa{\n  font-family: \"Font Awesome 6 Pro\"!important;\n}\n\n.osjs-panel-item .logo-here img {\n  width: 75px;\n  padding: 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
